import React, { useEffect, useState } from "react";
import Duration from "./images/duration.png";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
} from "recharts";

const BrandInsightsTabs = ({ barData, missingData }) => {
  const [showIcon, setShowIcon] = useState(false);

  const [activeTab, setActiveTab] = useState("brands");
  const transformedBarData = barData?.map((item) => ({
    name: item.brand,
    Questions: item.count,
  }));
  useEffect(() => {
    const storedStart = localStorage.getItem("startDate");
    const storedEnd = localStorage.getItem("endDate");

    if (!storedStart || !storedEnd) {
      setShowIcon(false);
      return;
    }

    const startDate = new Date(storedStart);
    const endDate = new Date(storedEnd);

    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);

    const isDefaultStart =
      startDate.getFullYear() === firstDayOfMonth.getFullYear() &&
      startDate.getMonth() === firstDayOfMonth.getMonth() &&
      startDate.getDate() === firstDayOfMonth.getDate();

    const isDefaultEnd =
      endDate.getFullYear() === today.getFullYear() &&
      endDate.getMonth() === today.getMonth() &&
      endDate.getDate() === today.getDate();

    setShowIcon(!(isDefaultStart && isDefaultEnd));
  }, []);

  return (
    <div className="brand-tabs">
      {showIcon && (
        <img src={Duration} alt="duration" className="duration-icon" />
      )}
      <h3>Brand Questions Overview</h3>
      <div className="tabs">
        <button
          className={activeTab === "brands" ? "active" : ""}
          onClick={() => setActiveTab("brands")}
        >
          Top Brands
        </button>
        <button
          className={activeTab === "missing" ? "active" : ""}
          onClick={() => setActiveTab("missing")}
        >
          Missing Brands
        </button>
      </div>
      <div className="tab-content">
        {activeTab === "brands" ? (
          barData && barData?.length > 0 ? (
            <ResponsiveContainer width="100%" height={400}>
              <BarChart data={transformedBarData} margin={{ bottom: 30 }}>
                <XAxis
                  dataKey="name"
                  interval={0}
                  angle={-40}
                  textAnchor="end"
                  tick={{ fontSize: 11 }}
                  height={70}
                />
                <YAxis allowDataOverflow={false} />
                <Tooltip
                  contentStyle={{
                    borderRadius: "5px",
                  }}
                />
                <Bar dataKey="Questions" fill="#00C49F" radius={[4, 4, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          ) : (
            <p>No brand data available</p>
          )
        ) : (
          <div className="missing-list">
            {missingData && missingData?.length === 0 ? (
              <p>No missing brands</p>
            ) : (
              missingData?.map((item, index) => (
                <div key={index} className="missing-item">
                  <span>{item?.brand ? item?.brand : ""}</span>
                  <span
                    className={`status ${item?.status
                      ?.toLowerCase()
                      ?.replace(" ", "-")}`}
                  >
                    {item?.status ? item.status : ""}
                  </span>
                </div>
              ))
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BrandInsightsTabs;
